export default __webpack_public_path__ + "69e047fd63481403b92b4ae5c5e2df6c.pdf";